import type React from 'react';
import { useMediaUtils } from './useMediaUtils';

export const useHtmlVideoHandler = () => {
  const { isFirstPlay, playbackDuration, getPercentage, push } = useMediaUtils('zngly_media_html5_video');

  const onPlay = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    if (!isFirstPlay.current) {
      isFirstPlay.current = true;
      playbackDuration.current = (e.target as HTMLVideoElement).duration;
      push('play');
    }
  };

  const onPause = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    // get the duration of the video if not set yet
    playbackDuration.current = (e.target as HTMLVideoElement).duration;
  };

  const onTimeUpdate = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    const target = e.target as HTMLVideoElement;
    const currentTime = target.currentTime;
    const duration = target?.duration;

    if (!duration || !currentTime) return;

    if (duration === 0) {
      // if there is no duration yet, set it
      playbackDuration.current = duration;
      return;
    }

    if (!isFirstPlay.current) {
      // if it is not the first play yet then we need to set it
      isFirstPlay.current = true;
      playbackDuration.current = duration;
      push('play');
      return;
    }

    const percentage = getPercentage(currentTime, duration);
    if (!!percentage) push(percentage);
  };

  return {
    onPlay,
    onPause,
    onTimeUpdate,
  };
};
